module.exports = __webpack_public_path__ + "img/roulette_in.4db59d5e.png";